import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { DangerRowProps } from "./DangerRowProps";

export function DangerRow({ name, values }: DangerRowProps) {

    const styles = StyleSheet.create({
        center: {
            flexDirection: "row"
        },
        border: {
            borderColor: "rgb(51, 102, 153)",
            border: "solid 1px 1px 1px 1px",
            padding: "5px",
            width: "50%",
            height: "auto"
        }
    });

    const renderValue = (val: any) => {
        if (!val) return "BRAK";
        return val;
    };

    const backgroundColor = (risk: string) => {
        if (risk === "Niskie") return "rgb(34, 178, 76)";
        else if (risk === "Średnie") return "rgb(245, 230, 37)";
        else if (risk === "Wysokie") return "rgb(235, 104, 100)";
        else if (risk === "Bardzo wysokie") return "rgb(34, 34, 34)";
        return "";
    };

    const color = (risk: string) => {
        if (risk === "Niskie") return "white";
        else if (risk === "Średnie") return "black";
        else if (risk === "Wysokie") return "white";
        else if (risk === "Bardzo wysokie") return "white";
        return "";
    };

    const renderCells = (values: any): string | JSX.Element | JSX.Element[] => {
        return values.map((x: any, i: any) => (
            <Text key={i} style={{ ...styles.border, flexGrow: 1, color: color(x), backgroundColor: backgroundColor(x) }}>{renderValue(x)}</Text>
        ));
    };

    return (
        <View style={styles.center}>
            <Text style={styles.border}>{name}</Text>
            <View style={{ width: "50%", display: "flex", flexDirection: "row" }}>
                {renderCells(values)}
            </View>
        </View>
    );
}
